/** @format */

import React, { ChangeEvent } from 'react';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { Checkbox, FormControl, Input, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import I18n from '../Translate/I18n';
import i18n from 'i18next';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';

type CustomMultiSelectProps = {
    classes: any;
    callback: (event: ChangeEvent<{ name?: string | undefined; value: unknown }>) => void;
    value: any;
    name: string | undefined;
    isElementsFromApi: boolean;
    elements: any;
    elementItemValue: number | string;
    elementItemName: number | string;
    label: string;
    showReversedSelect?: boolean;
    showSelectAllButton?: boolean;
};

const CustomMultiSelect = (props: CustomMultiSelectProps): React.ReactElement => {
    const {
        classes,
        callback,
        value,
        name,
        elements,
        isElementsFromApi,
        elementItemValue,
        elementItemName,
        label,
        showReversedSelect = false,
        showSelectAllButton = false,
    } = props;

    const renderSelectedValue = (selected: any): string => {
        let con = '';

        if (isElementsFromApi) {
            if (elements && elements['hydra:member']) {
                elements['hydra:member'].map((el: any) => {
                    selected.map((el2: any) => {
                        if (el2 === el[elementItemValue]) {
                            con += i18n.t(el[elementItemName]) + ', ';
                        }
                    });
                });
            }
        } else {
            if (elements) {
                elements.map((el: any) => {
                    selected.map((el2: any) => {
                        if (el2 === el[elementItemValue]) {
                            con += i18n.t(el[elementItemName]) + ', ';
                        }
                    });
                });
            }
        }

        return con;
    };

    const getAllValuesAtOnce = (): Array<string | number> => {
        let value = [];
        if (isElementsFromApi) {
            if (elements && elements['hydra:member']) {
                value = elements['hydra:member'].map((el: any) => {
                    return el[elementItemValue];
                });
            }
        } else {
            if (elements) {
                value = elements.map((el: any) => {
                    return el[elementItemValue];
                });
            }
        }

        return value;
    };

    const checkForAllSelected = (): boolean => {
        let checked = false;

        if (isElementsFromApi && elements) {
            checked = !!(elements['hydra:member'] && elements['hydra:member'].length === value.length);
        }

        if (value.length === 0) {
            checked = false;
        }

        return checked;
    };
    return (
        <FormControl fullWidth className={classes.selectFormControl}>
            <InputLabel classes={{ root: classes.SelectFromRestSelectLabelRoot }}>
                <I18n trans={label} />
            </InputLabel>
            <Select
                MenuProps={{
                    className: classes.selectMenu,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    elevation: 0,
                    getContentAnchorEl: null,
                }}
                classes={{
                    select: classes.select,
                    selectMenu: classes.SelectFromRestSelectMenu,
                }}
                multiple
                name={name}
                value={value}
                onChange={(event: any): void => {
                    if (event.target.value.includes(-1)) {
                        if (isElementsFromApi) {
                            if (elements && elements['hydra:member'] && event.target.value.length > 1) {
                                event.target.value = [];
                            }

                            if (elements && elements['hydra:member'] && event.target.value.length === 1) {
                                event.target.value = getAllValuesAtOnce();
                            }
                        } else {
                            if (elements && event.target.value.length > 1) {
                                event.target.value = [];
                            }

                            if (elements && event.target.value.length === 1) {
                                event.target.value = getAllValuesAtOnce();
                            }
                        }
                    }
                    callback(event);
                }}
                input={<Input />}
                renderValue={(selected): string => renderSelectedValue(selected)}
            >
                {showSelectAllButton && (
                    <MenuItem
                        key={-1}
                        value={-1}
                        classes={{
                            root: classes.multiSelectMenuItem,
                            selected: classes.selectMenuItemSelected,
                        }}
                        style={{ borderBottom: '1px solid #000' }}
                    >
                        <Checkbox checked={checkForAllSelected()} />
                        <I18n trans={'general:common.choose_all'} />
                    </MenuItem>
                )}
                {isElementsFromApi &&
                    elements &&
                    elements['hydra:member'].map((el: any) => (
                        <MenuItem
                            key={el[elementItemValue]}
                            value={el[elementItemValue]}
                            classes={{
                                root: classes.multiSelectMenuItem,
                                selected: classes.selectMenuItemSelected,
                            }}
                        >
                            <Checkbox checked={value.includes(el[elementItemValue])} />
                            <I18n trans={el[elementItemName]} />
                        </MenuItem>
                    ))}
                {!isElementsFromApi &&
                    elements &&
                    elements.map((el: any) => (
                        <MenuItem
                            key={el[elementItemValue]}
                            value={el[elementItemValue]}
                            classes={{
                                root: classes.multiSelectMenuItem,
                                selected: classes.selectMenuItemSelected,
                            }}
                        >
                            {showReversedSelect ? (
                                <Checkbox checked={!value.includes(el[elementItemValue])} />
                            ) : (
                                <Checkbox checked={value.includes(el[elementItemValue])} />
                            )}
                            <I18n trans={el[elementItemName]} />
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
};

export default withStyles(oplAppStyle)(CustomMultiSelect);
